import React from 'react';

import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

import {
    getIsShowAddress,
    getIsShowAddressForm,
} from '../../store/selectors/deliveryStep/deliveryStep';
import {Collapse} from '../collapse/collapse';
import {CustomerAddressesConnected} from '../customerAddresses/customerAddresses';
import {DeliveryFormFields} from '../deliveryFormFields/deliveryFormFields';
import {DeliveryFormTitle} from '../deliveryFormTitle/deliveryFormTitle';

export type PropsType = {
    isShowAddress: boolean;
    isShowAddressForm: boolean;
};

/**
 * Delivery form for user with address for checkout
 *
 * @constructor
 */
export const DeliveryFormForUserWithAddress: React.FC<PropsType> = ({
    isShowAddress,
    isShowAddressForm,
}) => {
    const {isOneStepAvailable} = useIsOneStepAvailable();

    return (
        <>
            <CustomerAddressesConnected type="shipping" />
            <Collapse
                isOpen={isOneStepAvailable ? isShowAddress || isShowAddressForm : isShowAddress}
            >
                <CustomerAddressesConnected type="billing" />
            </Collapse>
            <Collapse isOpen={isOneStepAvailable ? false : isShowAddressForm}>
                <DeliveryFormTitle isRequired>Billing address</DeliveryFormTitle>
                <DeliveryFormFields target="billingAddress" />
            </Collapse>
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isShowAddress: getIsShowAddress(store),
    isShowAddressForm: getIsShowAddressForm(store),
});

export const DeliveryFormForUserWithAddressConnected = connect(mapStateToProps)(
    DeliveryFormForUserWithAddress,
);
